<template>
  <div class="yxtbiz-ai-training-design-detail">
    <div>
      <yxt-button @click="$emit('goback')"
        >返回</yxt-button
      >
      <span class="pull-right">
        <yxt-button
        v-loading.fullscreen.lock="fullscreenclear"
        @click="clearAll()"
        >一键清空</yxt-button
      >
      <yxt-button
        type="primary"
        v-loading.fullscreen.lock="fullscreenexport"
        @click="exportLearningMap"
        >导出学习地图</yxt-button
      >
      </span>
     
  </div>
    <yxt-container class="clearfix">
      <yxt-aside class="mt24" width="150px">
        <div class="color-gray-8">点击下方步骤按钮，<br />开始生成</div>
        <yxt-menu
          :default-active="defaultSelect"
          class="yxt-menu-vertical-demo"
        >
          <yxt-menu-item
            :key="item.value"
            v-for="item of leftData"
            :index="item.value"
            @click="clickLeft(item)"
          >
            <span slot="title">{{ item.name }}</span>
          </yxt-menu-item>
        </yxt-menu></yxt-aside
      >
      <yxt-main>
        <div class="lh32 mb16 font-size-24 weight-medium">
          {{ data ? data.learningMapName : '-' }}
        </div>
        <div class="mb24" :key="index" v-for="(item, index) of resultData">
          <div
            class="lh26 mb12 font-size-18 weight-medium"
            :class="'scrollInto' + item.id"
          >
            任务{{ index + 1 }}：{{ item.period }}
          </div>
          <template v-if="item.tasks">
            <div :key="num" v-for="(itemChild, num) of item.tasks">
              <div
                class="layout-flex"
                :key="letfItemChild.value"
                v-for="letfItemChild of leftData"
              >
                <template
                  v-if="
                    itemChild[letfItemChild.value] ||
                    (editSetect &&
                      editSetect.taskid === itemChild.id &&
                      editSetect.leftCode === letfItemChild.value)
                  "
                >
                  <div class="lh42 left-form-width mb18">
                    {{ letfItemChild.name }}{{ num + 1 }}：
                  </div>
                  <div class="flex-1 mb18">
                    <yxt-input
                      :disabled="
                        getDisable(item, itemChild, letfItemChild, num)
                      "
                      type="textarea"
                      autosize
                      v-model="itemChild[letfItemChild.value]"
                    >
                    </yxt-input>
                  </div>
                  <div class="ml18 mb18 right-form-width lh42">
                    <yxt-button
                      type="text"
                      :disabled="isDisable"
                      v-if="getDisable(item, itemChild, letfItemChild, num)"
                      @click="edit(item, itemChild, letfItemChild, num)"
                      >编辑</yxt-button
                    >
                    <template v-else>
                      <yxt-button
                        type="text"
                        @click="save(itemChild[letfItemChild.value])"
                        >保存</yxt-button
                      >
                      <yxt-button type="text" @click="cancel()"
                        >取消</yxt-button
                      >
                    </template>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
      </yxt-main>
    </yxt-container>
    <div ref="aiboxRefdv">
      <yxtbiz-aibox-unify
        ref="aiboxRef"
        v-if="aiboxVisible"
        :app-id="appId"
        :carry-parmas="carryParmas"
        :api-map="apiMap"
        @close="aiboxVisible = false"
        @processEnd="processEnd"
      ></yxtbiz-aibox-unify>
    </div>
  </div>
</template>
  
  <script>
import {
  getLearningMapDetail,
  learningMapSetEnv,
  saveLearningMapPeriod,
  exportLearningMap,
  learningMapClear
} from '../service';

export default {
  components: {},
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      leftData: [
        {
          name: '课程主题',
          value: 'taskName'
        },
        {
          name: '学习目标',
          value: 'goal'
        },
        {
          name: '学习内容',
          value: 'content'
        },
        {
          name: '知识点',
          value: 'knowledge'
        },
        {
          name: '技能点',
          value: 'skill'
        },
        {
          name: '学习方式',
          value: 'mode'
        },
        {
          name: '检验方式',
          value: 'verification'
        },
        {
          name: '学习时长',
          value: 'duration'
        }
      ],
      data: {},
      resultData: [],
      defaultSelect: '',
      editSetect: null,
      processData: {},
      aiboxVisible: false,
      appId: 'taskName',
      carryParmas: {},
      aiParam: {},
      processLoading: '生成中...',
      fullscreenexport: false,
      fullscreenclear: false
    };
  },
  created() {
    this.getLearningMapDetail();
  },
  mounted() {
    document.body.appendChild(this.$refs.aiboxRefdv);
  },
  computed: {
    isDisable() {
      return !!this.editSetect;
    },
    apiMap() {
      return {
        appDetail: `${window.feConfig.common.apiBaseUrl}aiassist/learning/map/app/info`,
        assistantQa: `${window.feConfig.common.apiBaseUrl}aiassist/event_stream/stu/learning/map/ask`
      };
    }
  },
  methods: {
    clearAll(){
      this.$confirm('确认是否清空?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          learningMapClear(this.id)
            .then(() => {
              this.getLearningMapDetail()
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    getDisable(item, itemChild, letfItemChild, taskindex) {
      if (this.editSetect) {
        return !(
          this.editSetect.leftCode === letfItemChild.value &&
          this.editSetect.taskindex === taskindex &&
          this.editSetect.id === item.id
        );
      }
      return true;
    },
    getLearningMapDetail() {
      getLearningMapDetail(this.id)
        .then(res => {
          this.data = res;
          this.resultData = res.resultData ? res.resultData : [];
        })
        .finally(() => {});
    },
    clickLeft(val) {
      this.processData.index = 0;
      this.processData.code = val.value;
      this.appId = val.value;
      this.sendAiBox();
    },
    sendAiBox() {
      this.aiboxVisible = false;
      this.processData.finish = false;
      this.processData.first = false;
      const index = this.processData.index;
      const code = this.processData.code;
      if (
        this.resultData &&
        this.resultData[index] &&
        this.resultData[index].tasks &&
        this.resultData[index].tasks.length > 0
      ) {
        this.resultData[index].tasks.map(item => {
          item[code] = this.processLoading;
          return item;
        });
        this.$forceUpdate();
      } else {
        this.processData.first = true;
        this.resultData[index].tasks = [
          {
            [code]: this.processLoading
          }
        ];
      }
      this.setAiBox(code, this.resultData[index].id);
      // this.processEnd();
    },
    // 唤起aibox
    setAiBox(appCode, periodId) {
      learningMapSetEnv({
        id: this.id,
        appCode,
        periodId
      })
        .then(res => {
          this.carryParmas = {
            appCode,
            recordId: res.recordId
          };
          this.aiboxVisible = true;
        })
        .finally(() => {});
    },
    edit(item, itemChild, letfItemChild, taskindex) {
      let notEdit = false;
      for (const itemtask of item.tasks) {
        for (const datavalue of this.leftData) {
          if (itemtask[datavalue.value] === this.processLoading) {
            notEdit = true;
            break;
          }
        }
        if (notEdit) {
          break;
        }
      }
      if (notEdit) {
        this.$message({
          showClose: false,
          message: '有生成中的数据，不支持修改',
          type: 'error'
        });
        return;
      }

      const selectData = {
        leftCode: letfItemChild.value, // 左侧点击code
        taskindex, // 任务序号
        id: item.id, // 阶段id
        taskid: itemChild.id,
        oldvalue: this.deepCopy(itemChild)
      };
      this.editSetect = selectData;
    },
    save(data) {
      if (!data) {
        this.$message({
          showClose: false,
          message: '请输入内容',
          type: 'error'
        });
        return;
      }
      this.saveLearningMapPeriod(
        this.editSetect.id,
        this.resultData.find(item => item.id === this.editSetect.id).tasks
      );
    },
    cancel() {
      if (this.editSetect) {
        this.resultData.map(item => {
          if (item.id === this.editSetect.id) {
            item.tasks[this.editSetect.taskindex] = this.editSetect.oldvalue;
          }
          return item;
        });
        this.editSetect = null;
      }
    },
    processEnd(res) {
      console.log('processEnd任务' + (this.processData.index + 1) + res);
      // eslint-disable-next-line no-useless-escape
      const reg = /(?:\d+\.)\s*(.*?)(?=\d+\.|$)/gs;
      const resultAll = res.matchAll(reg);
      let result = [];
      for (const item of resultAll) {
        // console.log(item[0]);
        result.push(item[1]);
      }
      if (this.processData.first) {
        let orderIndex = 0;
        this.resultData[this.processData.index].tasks = [];
        for (const item of result) {
          const id = this.generateSnowflakeId();
          this.resultData[this.processData.index].tasks.push({
            [this.processData.code]: item,
            id,
            orderIndex
          });
          orderIndex++;
        }
      } else {
        this.resultData[this.processData.index].tasks.map((itemTask, index) => {
          if (result.length >= index) {
            itemTask[this.processData.code] = result[index];
          }
          return itemTask;
        });
        this.$forceUpdate();
      }
      this.saveLearningMapPeriod(
        this.resultData[this.processData.index].id,
        this.resultData[this.processData.index].tasks
      );
      this.sendNextAiBox();
    },
    sendNextAiBox() {
      this.processData.finish = true;
      if (
        this.resultData &&
        this.resultData.length > this.processData.index + 1
      ) {
        this.processData.index++;
        this.sendAiBox();
        setTimeout(() => {
          const firstErrorDom = document.querySelector(
            '.scrollInto' + this.resultData[this.processData.index].id
          );
          if (firstErrorDom) {
            firstErrorDom.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }, 300);
      } else {
        this.$message({
          showClose: false,
          message:
            this.leftData.find(item => item.value === this.processData.code)
              .name + '生成完成',
          type: 'success'
        });
      }
    },
    saveLearningMapPeriod(id, data) {
      saveLearningMapPeriod(this.id, id, data)
        .then(res => {
          this.$message({
            showClose: false,
            message: '保存成功',
            type: 'success'
          });
          this.editSetect = null;
        })
        .finally(() => {});
    },
    exportLearningMap() {
      this.fullscreenexport = true;
      exportLearningMap(this.id)
        .then(res => {
          this.$confirm('正在下载导出文件，请在下载中心查看', '查看导出文件', {
            confirmButtonText: '查看',
            cancelButtonText: '取消',
            type: 'success'
          })
            .then(() => {
              let href = window.location.origin + '/down/#/download';
              window.open(href, '_blank');
            })
            .catch(() => {});
        })
        .finally(() => {
          this.fullscreenexport = false;
        });
    },
    generateSnowflakeId() {
      const timestamp = new Date().getTime().toString(16);
      const random = Math.floor(Math.random() * 10000)
        .toString(16)
        .padStart(4, '0');
      const snowflakeId = timestamp + random;
      return snowflakeId;
    },
    deepCopy(obj) {
      if (obj === null || typeof obj !== 'object') {
        return obj;
      }

      let copy = Array.isArray(obj) ? [] : {};

      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          copy[key] = this.deepCopy(obj[key]);
        }
      }

      return copy;
    }
  },
  beforeDestroy() {
    this.aiboxVisible = false;
    document.body.removeChild(this.$refs.aiboxRefdv);
  }
};
</script>